import { useTranslation } from 'react-i18next';
import { dismissToast, useToasts, type ToastKind } from './toast-store';

/** The toast kinds use the status colours already defined for alerts: done / run / stop. */
const CLASS: Record<ToastKind, string> = { success: 'done', warning: 'run', error: 'stop' };
const GLYPH: Record<ToastKind, string> = { success: '●', warning: '▸', error: '■' };

/**
 * Mounted once, at the root. `role="status"` for a success (polite), `role="alert"` for a warning or
 * a failure (assertive), so a screen reader announces a refusal at once and a confirmation without
 * interrupting what it was reading.
 */
export function ToastHost() {
  const { t } = useTranslation();
  const toasts = useToasts();
  if (toasts.length === 0) return null;
  return (
    <div className="mk-toasts" aria-live="polite">
      {toasts.map((x) => (
        <div
          key={x.id}
          className={`mk-toast mk-alert mk-alert-${CLASS[x.kind]}`}
          role={x.kind === 'success' ? 'status' : 'alert'}
        >
          <span aria-hidden>{GLYPH[x.kind]}</span>
          <div>{x.message}</div>
          <button type="button" className="mk-toast-x" aria-label={t('toast.dismiss')} onClick={() => { dismissToast(x.id); }}>×</button>
        </div>
      ))}
    </div>
  );
}
